<template>
  <div>
    <side-nav
      v-if="!staticSideNav"
      :show-global-link="showGlobalLink"
    ></side-nav>

    <static-side-nav
      v-if="staticSideNav"
      :show-global-link="showGlobalLink"
    ></static-side-nav>

    <div class="flex flex-col w-full min-h-screen">
      <div class="relative h-40 bg-main-header">
        <div class="flex justify-center items-center h-full text-white">
          <div class="text-center">
            <p class="text-1xl font-semibold mb-4">Create your Vault</p>
            <p class="text-4.5xl font-light">
              {{ steps[current_step].long_name }}
            </p>
          </div>
        </div>
      </div>

      <div class="p-4 pt-2 bg-brand-lightest">
        <stepper :current="current_step" :steps="steps"></stepper>
      </div>

      <component
        v-for="(step_details, step) in steps"
        :key="step"
        :step="step"
        :is="step_details.template"
        v-if="current_step == step"
        :current-step="current_step"
        :current-sub-step="current_sub_step"
        :detail-review="detail_review"
        v-model="form"
        :steps="steps"
        :subscriptions="subscriptions"
        :payment-types="paymentTypes"
        @go-to="goTo"
        @update-form="updateForm"
        @getSubscriptions="getSubscriptions"
      ></component>
    </div>
  </div>
</template>

<script>
import Stepper from "./Stepper";
import PropertyDetails from "./PropertyDetails";
import PersonalDetails from "./PersonalDetails";
import SelectSubscription from "./SelectSubscription";
import BillingDetails from "./BillingDetails";
import BusinessBillingDetails from "./BusinessBillingDetails";
import VaultDetails from "./VaultDetails";
import BusinessPersonalDetails from "./BusinessPersonalDetails";
import Finish from "./Finish";
import BusinessFinish from "./BusinessFinish";
import FinishAddVault from "./FinishAddVault";
import BusinessFinishAddVault from "./BusinessFinishAddVault";

export default {
  components: {
    Stepper,
    PropertyDetails,
    PersonalDetails,
    BusinessPersonalDetails,
    BusinessBillingDetails,
    SelectSubscription,
    BillingDetails,
    VaultDetails,
    Finish,
    BusinessFinish,
    FinishAddVault,
    BusinessFinishAddVault,
  },

  props: [
    "steps",
    "static-side-nav",
    "value",
    "roles",
    "subscriptions",
    "payment-types",
    "current-step",
    "current-sub-step",
    "show-global-link",
  ],

  data() {
    return {
      form: _.cloneDeep(this.value),
      current_step: this.currentStep != "" ? this.currentStep : 3,
      current_sub_step: this.currentSubStep != "" ? this.currentSubStep : 1,
      detail_review: false,
    };
  },

  methods: {
    getSubscriptions(payload) {
      this.$emit('getSubscriptions', payload);
    },
    updateForm(payload) {
      this.form = payload.form;
      if (payload.submit != undefined && payload.submit == true) {
        this.submitData();
      }
    },
    goTo(payload) {
      this.current_step =
        payload.next_step != undefined ? payload.next_step : 1;
      this.current_sub_step =
        payload.next_sub_step != undefined ? payload.next_sub_step : 1;
      this.detail_review =
        payload.detail_review != undefined ? payload.detail_review : false;
    },
    submitData() {
      this.$emit("submit-data", {
        form: this.form,
      });
    },
  },

  watch: {
    form: {
      deep: true,
      handler: function () {
        this.$emit("input", this.form);
      },
    },
  },
};
</script>